module.exports = __webpack_public_path__ + "img/OrderStage.b8b0ab49.svg";